import React from "react";
import RedirectPage from "./_redirect";
import { PLAYSTORE_URL } from "../constants";

export default function IOSPage() {
  return (
    <RedirectPage
      path={PLAYSTORE_URL}
      text="Redirecting to the Play Store for oneCoach..."
      title="oneCoach Android App"
      desc="Easy step-by-step online tennis instruction broken down so you can learn tennis on autopilot. Download the oneCoach Android app here."
    />
  );
}
